import axios from "axios";
import {handleError, handleResponse} from '@/helpers/http-methods'

const HTTP = axios.create(
//   {
//   baseURL : `http://localhost:8082/`
// }
)

// Add a response interceptor
HTTP.interceptors.response.use(
  function (response) {
    handleResponse(response);
    return response;
  }, function (error) {
    handleError(error);
    return Promise.reject(error);
  }
);

export {HTTP};


// WEBPACK FOOTER //
// ./src/helpers/http-common.js